import React from "react";
import styled from "styled-components";
import { useMobile } from "../../utils/mobile";

const StyledButton = styled.button(
  ({ buttonStyle, theme, isMobile, disabled }) => ({
    backgroundColor:
      buttonStyle === "border-linear"
        ? theme.color.white
        : disabled
        ? "#D3DDED"
        : theme.color.mainBlue,
    color:
      buttonStyle === "border-linear"
        ? disabled
          ? "#D3DDED"
          : theme.color.mainBlue
        : theme.color.white,
    fontSize: 16,
    fontWeight: 600,
    border:
      buttonStyle === "border-linear"
        ? disabled
          ? "1.4px solid #D3DDED"
          : `1.4px solid ${theme.color.mainBlue}`
        : "none",
    fontFamily: "Heebo, sans-serif",
    width: isMobile ? "100%" : 100,
    height: 42,
    borderRadius: 10,
    cursor: "pointer",
    lineHeight: "41px",

    "&:hover": {
      background:
        buttonStyle === "border-linear"
          ? "#ECF3FF"
          : disabled
          ? "#D3DDED"
          : theme.color.mainBlue,
    },
  })
);

const Button = ({ notFullWidth, buttonStyle = "main", ...props }) => {
  const isMobile = useMobile();

  return (
    <StyledButton
      fullWidth={!notFullWidth}
      buttonStyle={buttonStyle}
      isMobile={isMobile}
      disabled={props.disabled}
      {...props}
    />
  );
};

export default Button;
